export default "__VITE_ASSET__BpJG2xoD__"